module.exports = __webpack_public_path__ + "static/media/viziya-logo.56587630.svg";